import React, { useEffect, useState } from 'react';
import DataGridTable from '../components/DataGridTable';
import Button from '@mui/material/Button';
import columns from '../components/columns/PostColumns';
import {
    GridActionsCellItem,
} from '@mui/x-data-grid';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import useAppStore from "../appStore";
import axios from "axios";
import toast, { Toaster } from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';

const Category = () => {
    const [records, setRecords] = useState([]);
    const [loading, setLoading] = useState(true);
    const [recordColumns, setRecordColumns] = useState(columns);
    const baseURL = process.env.REACT_APP_API_URL;
    const { token, updateSelectedPost } = useAppStore();
    const navigate = useNavigate();

    useEffect(() => {
        const hasActionColumn = columns.some((col) => col.field === 'actions');
        if (!hasActionColumn) {
            const actionColumn = {
                field: 'actions',
                type: 'actions',
                headerName: 'Actions',
                width: 100,
                cellClassName: 'actions',
                getActions: ({ id }) => {
                    return [
                        <GridActionsCellItem
                            icon={<DeleteIcon />}
                            label="Delete"
                            onClick={() => handleDeleteClick(id)}
                            color="inherit"
                        />,
                    ];
                },
            };

            setRecordColumns([...columns, actionColumn]);
        }
        setLoading(false);
    }, []);

    const handleEditClick = async (id) => {
        try {

        } catch (error) {
            console.error("Error fetching record:", error);
        }
    };

    const handleDeleteClick = async (id) => {

        confirmAlert({
            title: 'Confirm to submit',
            message: 'Are you sure to do this.',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => handleDelete(id)
                },
                {
                    label: 'No',
                    onClick: () => { }
                }
            ]
        });


    };

    const handleDelete = async (id) => {
        let posturl = baseURL + "/seller-post/" + id;
        await axios
            .delete(posturl, {
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    "Content-type": "Application/json",
                    Authorization: `Bearer ${token}`,
                },
            })
            .then(function (res) {
                console.log(res.data);
                getUsers();
                toast.success("Record has been deleted.");
            })
            .catch(function (error) {
                toast.error(error);
                console.log(error);
            });
    }

    useEffect(() => {
        getUsers();
    }, []);

    const getUsers = async () => {
        let posturl = baseURL + "/seller-post";
        await axios
            .get(posturl, {
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    "Content-type": "Application/json",
                    Authorization: `Bearer ${token}`,
                },
            })
            .then((res) => {
                setRecords(res.data);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    return (
        <div className='p-4 mx-4'>
            <Toaster />
            <h1 className='mt-5 text-2xl text-blue-600'>All Posts</h1>
            <div className='mt-10'>
                <div className='my-3 flex justify-end mr-4'>
                    <Button variant="outlined" size="small" onClick={() => { updateSelectedPost(''); navigate("/update-post") }}>Add Post</Button>
                </div>
                {!loading && (
                    <DataGridTable data={records} columns={recordColumns} />
                )}
            </div>
        </div >
    );
};

export default Category;
